import { useState } from "react";

const CustomCalendar = () => {
  // Current date ke basis par initial state
  const [selectedMonthIndex, setSelectedMonthIndex] = useState(new Date().getMonth()); 
  const [selectedYear, setSelectedYear] = useState(2009);
  const [view, setView] = useState("date"); // "date", "month", or "year"
  
  // Year slider range logic
  const [startYear, setStartYear] = useState(2009);
  const [endYear, setEndYear] = useState(2020);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const showMonthCalendar = () => {
    setView(view === "month" ? "date" : "month");
  };

  const showYearCalendar = () => {
    setView(view === "year" ? "date" : "year");
  };

  const handleMonthClick = (e, index) => {
    e.preventDefault();
    setSelectedMonthIndex(index);
    setView("date"); // Month select hote hi wapas calendar dikhega
  };

  const handleYearClick = (e, year) => {
    e.preventDefault();
    setSelectedYear(year);
    setView("date"); // Year select hote hi wapas calendar dikhega
  };

  const handleYearPrevClick = () => {
    setStartYear(startYear - 12);
    setEndYear(endYear - 12);
  };

  const handleYearNextClick = () => {
    setStartYear(startYear + 12);
    setEndYear(endYear + 12);
  };

  // Din nikalne ka dynamic logic
  const getDateClasses = (day) => {
    if (day <= 0) return "fz16 fw400 disabled"; // Previous month padding ke liye
    if ([8, 9, 12, 13, 15, 16, 19, 20, 21, 22].includes(day)) return "fz16 fw400 checked";
    if ([11, 14, 18, 23].includes(day)) return "fz16 fw400 dotted";
    return "fz16 fw400";
  };

  return (
    <>
      <div className="top-bar">
        <div className="top-bar__left hide-below-768">
          <h4 className="m-0 fw700 fz20 lh1 month-year-text">
            {/* Sirf yahan click events add kiye hain */}
            <span style={{ cursor: "pointer" }} onClick={showMonthCalendar}>
              {monthNames[selectedMonthIndex]}
            </span>{" "}
            <span style={{ cursor: "pointer" }} onClick={showYearCalendar}>
              {selectedYear}
            </span>
          </h4>
          <span className="fw400 fz12 timeCounter">09:35:58 Left</span>
          <button className="ts03 btn btn-month-year" onClick={showMonthCalendar}>
            <img
              className={`btn-month-year-img ${view !== "date" ? "btn-arrow-rotate" : ""}`}
              src="./assets/images/inner-pages/icons/icon-dropdown-arrow.svg"
              alt=""
            />
          </button>
        </div>
        <div className="bdrs20 top-bar__right">
          <span className="fz16 fw600">24</span>
          <img src="./assets/images/inner-pages/icons/icon-fire.svg" alt="" />
        </div>
        <button className="btn btn-calendar--mobile hide-above-768">
          <img src="./assets/images/inner-pages/icons/icon-m-calendar--blue.svg" alt="" />
        </button>
      </div>

      {view === "date" && (
        <div className="date-block hide-below-768">
          <div className="date-block--days">
            {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
              <span key={day} className="fz12 fw500">
                {day}
              </span>
            ))}
          </div>
          <div className="date-block--dates">
            {/* Static structure ko preserve kiya hai, logic ko dynamic handle kiya ja sakta hai */}
            {Array.from({ length: 35 }, (_, i) => {
              const day = i + 28;
              const displayDay = day > 31 ? day - 31 : day;
              return (
                <span key={i} className={getDateClasses(displayDay)}>
                  {displayDay}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {view === "month" && (
        <div className="month-block hide-below-768">
          <ul className="ff-poppins list-inline sep-cal-list">
            {monthNames.map((month, index) => (
              <li key={month}>
                <a
                  href="javascript:void(0)"
                  className={`btn fz14 fw500 btn-month ${monthNames[selectedMonthIndex] === month ? "selected" : ""}`}
                  onClick={(e) => handleMonthClick(e, index)}
                >
                  {month}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {view === "year" && (
        <div className="year-block hide-below-768">
          <div className="slider">
            <button
              className="prev"
              onClick={handleYearPrevClick}
              disabled={startYear <= 2000}
            >
              <img
                src="./assets/images/inner-pages/icons/icon-dropdown-arrow.svg"
                alt=""
              />
            </button>
            <span className="fw500 fz14">
              {startYear}-{endYear}
            </span>
            <button
              className="next"
              onClick={handleYearNextClick}
              disabled={endYear >= 2040}
            >
              <img
                src="./assets/images/inner-pages/icons/icon-dropdown-arrow.svg"
                alt=""
              />
            </button>
          </div>
          <ul className="ff-poppins list-inline sep-cal-list year-block-ul">
            {Array.from({ length: endYear - startYear + 1 }, (_, i) => {
              const year = startYear + i;
              return (
                <li key={year}>
                  <button
                    className={`btn fz14 fw500 btn-month ${selectedYear === year ? "selected" : ""}`}
                    onClick={(e) => handleYearClick(e, year)}
                  >
                    {year}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default CustomCalendar;